import { Component } from "@angular/core";

@Component({
  selector: "app-replacement-claim-reject",
  templateUrl: "./replacement-claim-reject.component.html",
  styleUrls: ["./replacement-claim-reject.component.less"],
})
export class ReplacementClaimRejectComponent {}
